
 import gsap from 'gsap';

 import PricingButton from "@/components/main/pricing/PricingButton";
 import RedHeadBox from "@/components/main/core/RedHeadBox";
 import SearchCircle from "@/components/main/core/SearchCircle"


 import cougar from "@/assets/images/main/example/dating/cougar.png"
 import dating from "@/assets/images/main/example/dating/dating.png"
 import lavalife from "@/assets/images/main/example/dating/lavalife.png"
 import mingle from "@/assets/images/main/example/dating/mingle.png"
 import sexfinder from "@/assets/images/main/example/dating/sexfinder.png"
 import sugar from "@/assets/images/main/example/dating/sugar.png"
 import validate from "@/assets/images/main/example/dating/validate.png"
 import want from "@/assets/images/main/example/dating/want.png"
 import xdating from "@/assets/images/main/example/dating/xdating.png"
 import xmatch from "@/assets/images/main/example/dating/xmatch.png"
 import isMobile from "@/mixins/isMob";




 export default {
   name: "DatingTab",
   components: { PricingButton, RedHeadBox, SearchCircle, isMobile},

   data() {
     return {
        date: new Date(),
        complete: false,
        datingServices: [
          {
            logo: cougar,
            isFound: true,
            email: 'name@email.com',
            service: 'dateacougar.com'
          },
          {
            logo: dating,
            isFound: true,
            email: 'name@email.com',
            service: 'datingforpartners.com'
          },
          {
            logo: lavalife,
            isFound: false,
            email: '',
            service: 'datingforpartners.com'
          },
          {
            logo: mingle,
            isFound: false,
            email: '',
            service: 'mingle2.com'
          },
          {
            logo: sexfinder,
            isFound: true,
            email: 'name@email.com',
            service: 'sexfinder.com'
          },
          {
            logo: sugar,
            isFound: true,
            email: 'name@email.com',
            service: 'sugardaddyforme.com'
          },
          {
            logo: validate,
            isFound: false,
            email: '',
            service: 'sugardaddyforme.com'
          },
          {
            logo: want,
            isFound: true,
            email: 'name@email.com',
            service: 'wantmatures.com'
          },
          {
            logo: xdating,
            isFound: false,
            email: '',
            service: 'xdating.com'
          },
          {
            logo: xmatch,
            isFound: true,
            email: 'name@email.com',
            service: 'xmatch.com'
          }
        ]
     }
   },
    mixins: [isMobile],

   methods: {

     datenow() {
       if (this.date.getMinutes())
       return `${this.date.getDate()}/${this.date.getMonth()+1}/${this.date.getFullYear()} ${this.date.getHours()}:${+this.date.getMinutes() <= 10 ? '0'+this.date.getMinutes() : this.date.getMinutes()}`
     },

     beforeEnter(el) {
        el.style.opacity = 0
        el.style.transform = 'translateY(60px)'
     },

     enter(el) {
        gsap.to(el, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: el.dataset.index*0.6
        })
     },

     end(is) {
       this.complete = is;
     }
   }
 }
 